var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _path8, _g11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLike({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1270_4198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6216 5.38425C12.6216 3.56804 14.0939 2.0957 15.9101 2.0957C17.7263 2.0957 19.1987 3.56804 19.1987 5.38425V9.1687C19.1987 9.49144 19.1763 9.81324 19.1264 10.135C19.1082 10.2524 19.09 10.3697 19.0787 10.4869C19.0428 10.8574 19.0866 11.3413 19.3384 11.6662L18.7371 12.2463C21.7523 13.7867 23.8184 16.9369 23.8184 20.5726C23.8184 21.5576 23.6667 22.507 23.3856 23.3984L22.3892 29.9048H14.2877V29.9021C9.28453 29.7943 5.27051 26.5318 5.27051 20.5726C5.27051 17.0696 6.94781 14.2496 9.48534 12.6595L9.47906 12.6545C9.65192 12.5344 9.85576 12.4122 10.0743 12.2811L10.0759 12.2802C10.7956 11.8488 11.6751 11.3215 12.1392 10.4592C12.5416 9.71159 12.6197 8.49825 12.6197 7.93575L12.6216 7.9366V5.38425Z",
    fill: "url(#paint0_linear_1270_4198)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6216 5.38425C12.6216 3.56804 14.0939 2.0957 15.9101 2.0957C17.7263 2.0957 19.1987 3.56804 19.1987 5.38425V9.1687C19.1987 9.49144 19.1763 9.81324 19.1264 10.135C19.1082 10.2524 19.09 10.3697 19.0787 10.4869C19.0428 10.8574 19.0866 11.3413 19.3384 11.6662L18.7371 12.2463C21.7523 13.7867 23.8184 16.9369 23.8184 20.5726C23.8184 21.5576 23.6667 22.507 23.3856 23.3984L22.3892 29.9048H14.2877V29.9021C9.28453 29.7943 5.27051 26.5318 5.27051 20.5726C5.27051 17.0696 6.94781 14.2496 9.48534 12.6595L9.47906 12.6545C9.65192 12.5344 9.85576 12.4122 10.0743 12.2811L10.0759 12.2802C10.7956 11.8488 11.6751 11.3215 12.1392 10.4592C12.5416 9.71159 12.6197 8.49825 12.6197 7.93575L12.6216 7.9366V5.38425Z",
    fill: "url(#paint1_radial_1270_4198)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6216 5.38425C12.6216 3.56804 14.0939 2.0957 15.9101 2.0957C17.7263 2.0957 19.1987 3.56804 19.1987 5.38425V9.1687C19.1987 9.49144 19.1763 9.81324 19.1264 10.135C19.1082 10.2524 19.09 10.3697 19.0787 10.4869C19.0428 10.8574 19.0866 11.3413 19.3384 11.6662L18.7371 12.2463C21.7523 13.7867 23.8184 16.9369 23.8184 20.5726C23.8184 21.5576 23.6667 22.507 23.3856 23.3984L22.3892 29.9048H14.2877V29.9021C9.28453 29.7943 5.27051 26.5318 5.27051 20.5726C5.27051 17.0696 6.94781 14.2496 9.48534 12.6595L9.47906 12.6545C9.65192 12.5344 9.85576 12.4122 10.0743 12.2811L10.0759 12.2802C10.7956 11.8488 11.6751 11.3215 12.1392 10.4592C12.5416 9.71159 12.6197 8.49825 12.6197 7.93575L12.6216 7.9366V5.38425Z",
    fill: "url(#paint2_radial_1270_4198)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6216 5.38425C12.6216 3.56804 14.0939 2.0957 15.9101 2.0957C17.7263 2.0957 19.1987 3.56804 19.1987 5.38425V9.1687C19.1987 9.49144 19.1763 9.81324 19.1264 10.135C19.1082 10.2524 19.09 10.3697 19.0787 10.4869C19.0428 10.8574 19.0866 11.3413 19.3384 11.6662L18.7371 12.2463C21.7523 13.7867 23.8184 16.9369 23.8184 20.5726C23.8184 21.5576 23.6667 22.507 23.3856 23.3984L22.3892 29.9048H14.2877V29.9021C9.28453 29.7943 5.27051 26.5318 5.27051 20.5726C5.27051 17.0696 6.94781 14.2496 9.48534 12.6595L9.47906 12.6545C9.65192 12.5344 9.85576 12.4122 10.0743 12.2811L10.0759 12.2802C10.7956 11.8488 11.6751 11.3215 12.1392 10.4592C12.5416 9.71159 12.6197 8.49825 12.6197 7.93575L12.6216 7.9366V5.38425Z",
    fill: "url(#paint3_radial_1270_4198)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6216 5.38425C12.6216 3.56804 14.0939 2.0957 15.9101 2.0957C17.7263 2.0957 19.1987 3.56804 19.1987 5.38425V9.1687C19.1987 9.49144 19.1763 9.81324 19.1264 10.135C19.1082 10.2524 19.09 10.3697 19.0787 10.4869C19.0428 10.8574 19.0866 11.3413 19.3384 11.6662L18.7371 12.2463C21.7523 13.7867 23.8184 16.9369 23.8184 20.5726C23.8184 21.5576 23.6667 22.507 23.3856 23.3984L22.3892 29.9048H14.2877V29.9021C9.28453 29.7943 5.27051 26.5318 5.27051 20.5726C5.27051 17.0696 6.94781 14.2496 9.48534 12.6595L9.47906 12.6545C9.65192 12.5344 9.85576 12.4122 10.0743 12.2811L10.0759 12.2802C10.7956 11.8488 11.6751 11.3215 12.1392 10.4592C12.5416 9.71159 12.6197 8.49825 12.6197 7.93575L12.6216 7.9366V5.38425Z",
    fill: "url(#paint4_radial_1270_4198)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6216 5.38425C12.6216 3.56804 14.0939 2.0957 15.9101 2.0957C17.7263 2.0957 19.1987 3.56804 19.1987 5.38425V9.1687C19.1987 9.49144 19.1763 9.81324 19.1264 10.135C19.1082 10.2524 19.09 10.3697 19.0787 10.4869C19.0428 10.8574 19.0866 11.3413 19.3384 11.6662L18.7371 12.2463C21.7523 13.7867 23.8184 16.9369 23.8184 20.5726C23.8184 21.5576 23.6667 22.507 23.3856 23.3984L22.3892 29.9048H14.2877V29.9021C9.28453 29.7943 5.27051 26.5318 5.27051 20.5726C5.27051 17.0696 6.94781 14.2496 9.48534 12.6595L9.47906 12.6545C9.65192 12.5344 9.85576 12.4122 10.0743 12.2811L10.0759 12.2802C10.7956 11.8488 11.6751 11.3215 12.1392 10.4592C12.5416 9.71159 12.6197 8.49825 12.6197 7.93575L12.6216 7.9366V5.38425Z",
    fill: "url(#paint5_radial_1270_4198)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6216 5.38425C12.6216 3.56804 14.0939 2.0957 15.9101 2.0957C17.7263 2.0957 19.1987 3.56804 19.1987 5.38425V9.1687C19.1987 9.49144 19.1763 9.81324 19.1264 10.135C19.1082 10.2524 19.09 10.3697 19.0787 10.4869C19.0428 10.8574 19.0866 11.3413 19.3384 11.6662L18.7371 12.2463C21.7523 13.7867 23.8184 16.9369 23.8184 20.5726C23.8184 21.5576 23.6667 22.507 23.3856 23.3984L22.3892 29.9048H14.2877V29.9021C9.28453 29.7943 5.27051 26.5318 5.27051 20.5726C5.27051 17.0696 6.94781 14.2496 9.48534 12.6595L9.47906 12.6545C9.65192 12.5344 9.85576 12.4122 10.0743 12.2811L10.0759 12.2802C10.7956 11.8488 11.6751 11.3215 12.1392 10.4592C12.5416 9.71159 12.6197 8.49825 12.6197 7.93575L12.6216 7.9366V5.38425Z",
    fill: "url(#paint6_radial_1270_4198)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6216 5.38425C12.6216 3.56804 14.0939 2.0957 15.9101 2.0957C17.7263 2.0957 19.1987 3.56804 19.1987 5.38425V9.1687C19.1987 9.49144 19.1763 9.81324 19.1264 10.135C19.1082 10.2524 19.09 10.3697 19.0787 10.4869C19.0428 10.8574 19.0866 11.3413 19.3384 11.6662L18.7371 12.2463C21.7523 13.7867 23.8184 16.9369 23.8184 20.5726C23.8184 21.5576 23.6667 22.507 23.3856 23.3984L22.3892 29.9048H14.2877V29.9021C9.28453 29.7943 5.27051 26.5318 5.27051 20.5726C5.27051 17.0696 6.94781 14.2496 9.48534 12.6595L9.47906 12.6545C9.65192 12.5344 9.85576 12.4122 10.0743 12.2811L10.0759 12.2802C10.7956 11.8488 11.6751 11.3215 12.1392 10.4592C12.5416 9.71159 12.6197 8.49825 12.6197 7.93575L12.6216 7.9366V5.38425Z",
    fill: "url(#paint7_linear_1270_4198)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1270_4198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0331 14.9346C24.0331 13.5253 22.8906 12.3828 21.4813 12.3828H18.6548C17.2455 12.3828 16.103 13.5253 16.103 14.9346C16.103 15.7205 16.4583 16.4234 17.017 16.8915C16.3993 17.3589 16 18.1008 16 18.934C16 19.7141 16.3501 20.4142 16.9017 20.8838C16.3501 21.3519 16 22.0502 16 22.8304V22.9562C16 23.6554 16.2812 24.2889 16.7367 24.7498C16.2818 25.1999 16 25.8246 16 26.515C16 27.8864 17.1117 28.9982 18.4831 28.9982H21.2868C22.6582 28.9982 23.7699 27.8864 23.7699 26.515C23.7699 26.0611 23.6481 25.6356 23.4354 25.2695C24.3055 24.863 24.9085 23.98 24.9085 22.9562V22.8303C24.9085 22.0407 24.5498 21.3349 23.9866 20.8668C24.5268 20.3974 24.8685 19.7047 24.8685 18.934C24.8685 17.9117 24.2673 17.0268 23.3993 16.6179C23.7939 16.1686 24.0331 15.5796 24.0331 14.9346Z",
    fill: "url(#paint8_linear_1270_4198)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_1270_4198)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.3115,
    y: 10.9561,
    width: 5.82021,
    height: 9.0435,
    rx: 2.9101,
    transform: "rotate(90 26.3115 10.9561)",
    fill: "url(#paint9_linear_1270_4198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.3115,
    y: 10.9561,
    width: 5.82021,
    height: 9.0435,
    rx: 2.9101,
    transform: "rotate(90 26.3115 10.9561)",
    fill: "url(#paint10_radial_1270_4198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.3115,
    y: 10.9561,
    width: 5.82021,
    height: 9.0435,
    rx: 2.9101,
    transform: "rotate(90 26.3115 10.9561)",
    fill: "url(#paint11_radial_1270_4198)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_1270_4198)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.21,
    y: 12.3828,
    width: 6.13569,
    height: 2.51555,
    rx: 1.25777,
    fill: "url(#paint12_linear_1270_4198)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_1270_4198)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.0107,
    y: 24.2412,
    width: 5.6636,
    height: 8.86086,
    rx: 2.8318,
    transform: "rotate(90 26.0107 24.2412)",
    fill: "url(#paint13_linear_1270_4198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.0107,
    y: 24.2412,
    width: 5.6636,
    height: 8.86086,
    rx: 2.8318,
    transform: "rotate(90 26.0107 24.2412)",
    fill: "url(#paint14_radial_1270_4198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.0107,
    y: 24.2412,
    width: 5.6636,
    height: 8.86086,
    rx: 2.8318,
    transform: "rotate(90 26.0107 24.2412)",
    fill: "url(#paint15_radial_1270_4198)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_1270_4198)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.9756,
    y: 25.9248,
    width: 5.37025,
    height: 1.4762,
    rx: 0.7381,
    fill: "url(#paint16_linear_1270_4198)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_i_1270_4198)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.3096,
    y: 19.9609,
    width: 5.96377,
    height: 10.1593,
    rx: 2.9101,
    transform: "rotate(90 27.3096 19.9609)",
    fill: "url(#paint17_linear_1270_4198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.3096,
    y: 19.9609,
    width: 5.96377,
    height: 10.1593,
    rx: 2.9101,
    transform: "rotate(90 27.3096 19.9609)",
    fill: "url(#paint18_radial_1270_4198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.3096,
    y: 19.9609,
    width: 5.96377,
    height: 10.1593,
    rx: 2.9101,
    transform: "rotate(90 27.3096 19.9609)",
    fill: "url(#paint19_radial_1270_4198)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_1270_4198)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.5859,
    y: 22.0547,
    width: 6.72485,
    height: 1.4762,
    rx: 0.7381,
    fill: "url(#paint20_linear_1270_4198)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_1270_4198)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 27.2637,
    y: 15.5107,
    width: 5.83326,
    height: 10.1136,
    rx: 2.9101,
    transform: "rotate(90 27.2637 15.5107)",
    fill: "url(#paint21_linear_1270_4198)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2637,
    y: 15.5107,
    width: 5.83326,
    height: 10.1136,
    rx: 2.9101,
    transform: "rotate(90 27.2637 15.5107)",
    fill: "url(#paint22_radial_1270_4198)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_f_1270_4198)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 19.1387,
    y: 16.7354,
    width: 7.17206,
    height: 2.51555,
    rx: 1.25777,
    fill: "url(#paint23_linear_1270_4198)"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9222 2.0957C14.1061 2.0957 12.6337 3.56804 12.6337 5.38425V7.9366L12.6318 7.93575C12.6318 8.49825 12.5537 9.71159 12.1514 10.4592C11.6873 11.3215 10.8077 11.8488 10.0881 12.2802C9.8689 12.4116 9.66449 12.5341 9.49121 12.6545C10.486 13.4514 12.5233 15.0436 12.5732 15.0061C12.6232 14.9686 14.917 13.7509 16.0576 13.1467L16.0091 12.4561C17.7852 12.4101 19.2108 10.9559 19.2108 9.1687V5.38425C19.2108 3.56804 17.7385 2.0957 15.9222 2.0957Z",
    fill: "url(#paint24_radial_1270_4198)"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_f_1270_4198)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 3.33789,
    width: 2.36981,
    height: 7.9974,
    rx: 1.18491,
    fill: "url(#paint25_linear_1270_4198)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1270_4198",
    x: 5.27051,
    y: 2.0957,
    width: 19.0479,
    height: 27.8096,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.87451 0 0 0 0 0.67451 0 0 0 0 0.568627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1270_4198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1270_4198",
    x: 14,
    y: 10.3828,
    width: 12.9082,
    height: 20.6152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1270_4198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_1270_4198",
    x: 17.2676,
    y: 10.9561,
    width: 9.54395,
    height: 5.82031,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.898039 0 0 0 0 0.690196 0 0 0 0 0.568627 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1270_4198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_1270_4198",
    x: 17.96,
    y: 11.1328,
    width: 8.63574,
    height: 5.01562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_1270_4198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_1270_4198",
    x: 17.1494,
    y: 24.2412,
    width: 9.36133,
    height: 6.16406,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.811765 0 0 0 0 0.568627 0 0 0 0 0.541176 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1270_4198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_1270_4198",
    x: 18.7256,
    y: 24.6748,
    width: 7.87012,
    height: 3.97656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_1270_4198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_i_1270_4198",
    x: 17.1504,
    y: 19.9609,
    width: 11.1592,
    height: 6.46387,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.831373 0 0 0 0 0.576471 0 0 0 0 0.505882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1270_4198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_1270_4198",
    x: 18.3359,
    y: 20.8047,
    width: 9.22461,
    height: 3.97656,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_1270_4198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_1270_4198",
    x: 17.1504,
    y: 15.5107,
    width: 10.6133,
    height: 6.33301,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.862745 0 0 0 0 0.658824 0 0 0 0 0.54902 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1270_4198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_f_1270_4198",
    x: 17.8887,
    y: 15.4854,
    width: 9.67188,
    height: 5.01562,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_1270_4198"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_f_1270_4198",
    x: 14.75,
    y: 2.08789,
    width: 4.87012,
    height: 10.4971,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.625,
    result: "effect1_foregroundBlur_1270_4198"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1270_4198",
    x1: 20.0803,
    y1: 12.0592,
    x2: 8.72452,
    y2: 33.7306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7AFA8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1270_4198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5078 3.51959) rotate(138.814) scale(3.70607 2.89161)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE6C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE6C7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1270_4198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.7477 16.0003) rotate(133.564) scale(7.41221 5.36952)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2C0A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2C0A5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1270_4198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.2942 16.891) rotate(135.794) scale(10.6892 6.58962)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDA895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDA895",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1270_4198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.8747 34.0002) rotate(-62.6117) scale(14.7421 26.2114)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C08494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C08494",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1270_4198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.5873 20.8687) rotate(-180) scale(15.534 23.9075)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.863834,
    stopColor: "#EDB29B",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDB29B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1270_4198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.7188 11.3817) rotate(38.8999) scale(1.56226 2.05738)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7C49C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDBBA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1270_4198",
    x1: 14.5444,
    y1: 31.1252,
    x2: 14.5444,
    y2: 27.6877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B57895"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B57895",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1270_4198",
    x1: 19.753,
    y1: 14.2311,
    x2: 19.753,
    y2: 29.599,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5755F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3748D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1270_4198",
    x1: 29.2216,
    y1: 10.9561,
    x2: 29.2216,
    y2: 19.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD8BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECB9A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1270_4198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.9707 19.1763) rotate(-90) scale(6.62598 2.65767)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFA995"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFA995",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1270_4198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8013 18.5286) rotate(127.367) scale(2.3211 1.55368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CA8C6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA8C6F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1270_4198",
    x1: 25.0269,
    y1: 13.0726,
    x2: 18.4131,
    y2: 13.0726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE7CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1270_4198",
    x1: 28.8425,
    y1: 25.0175,
    x2: 28.8425,
    y2: 33.1021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FECEB7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAA59E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1270_4198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.6743 30.5495) rotate(-90) scale(8.20767 1.55607)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF8196"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF8196",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1270_4198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.005 30.9709) rotate(-90) scale(6.72969 1.51308)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B57767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B57767",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1270_4198",
    x1: 25.0669,
    y1: 26.3296,
    x2: 19.2781,
    y2: 26.3296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD2C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD2C1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1270_4198",
    x1: 30.2915,
    y1: 20.8509,
    x2: 30.2915,
    y2: 30.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDDC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5B1A3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1270_4198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.2733 28.0622) rotate(-90) scale(9.21683 3.27876)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.139674,
    stopColor: "#CA8E96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CA8E96",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1270_4198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.831 27.2415) rotate(-90) scale(4.75329 1.92955)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB7E6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BB7E6C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1270_4198",
    x1: 25.9614,
    y1: 22.4594,
    x2: 18.7126,
    y2: 22.4594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE2C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE2C9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1270_4198",
    x1: 30.1803,
    y1: 15.5107,
    x2: 30.1803,
    y2: 25.6244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2AE9C"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1270_4198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.0969 23.0557) rotate(-90) scale(8.09375 3.75685)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D39797"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D39797",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1270_4198",
    x1: 25.9382,
    y1: 17.4251,
    x2: 18.2072,
    y2: 17.4251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE8CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE8CA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1270_4198",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.7068 6.16691) rotate(90) scale(6.32895 2.49784)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0A892"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0A892",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1270_4198",
    x1: 18.2467,
    y1: 5.5307,
    x2: 15.6922,
    y2: 5.5307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE7CA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.aa52c51cc7871af4caa4a9b1bf447802.svg";
export { ForwardRef as ReactComponent };